import React from 'react';
import { useRoutes } from 'react-router-dom';
import SignUpPage from 'pages/signup/SignUpPage';
import FindAccountPage from 'pages/findAccount/FindAccountPage';
import Unknown from 'pages/404/404';
import AdminRoute from './admin';
import RootRoute from './root';
import ReviewerRoute from './reviewer';

export default () =>
  useRoutes([
    // Root Pages #############################################################
    { path: '/sign-up/:role', element: <SignUpPage /> },
    { path: '/find-account/:role', element: <FindAccountPage /> },
    RootRoute,
    AdminRoute,
    ReviewerRoute,
    { path: '*', element: <Unknown /> },
  ]);
